exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2dVVNzNFMmSpD0jrGbP0Pl{color:#fa6400}span._1txyb7qvTQM4g2fmHMR4eX{color:#2a2a2a}\n", ""]);

// Exports
exports.locals = {
	"orange": "_2dVVNzNFMmSpD0jrGbP0Pl",
	"darkgrey": "_1txyb7qvTQM4g2fmHMR4eX"
};